import React from 'react';
import GradientSpinner from './GradientSpinner';
import '../App.css';

/** Full-viewport loading (auth gate, heavy pages). */
const PageLoader = () => (
  <div className="page-loader-screen">
    <GradientSpinner size={72} />
  </div>
);

export default PageLoader;
